import {
  RiDashboardLine,
  RiNotification3Line,
  RiLineChartLine,
  RiBuilding2Line,
  RiStore2Line,
  RiPieChartLine,
  RiUser3Line,
  RiPriceTag3Line,
  RiFileTextLine,
  RiCalendarCloseLine,
  RiShieldStarLine,
  RiFileListLine,
  RiEditBoxLine,
  RiCheckboxCircleLine,
  RiFileExcelLine,
  RiScales3Line,
  RiCalculatorLine,
  RiBillLine,
  RiHandCoinLine,
  RiPieChart2Line,
  RiBook2Line,
  RiCustomerServiceLine,
  RiClipboardLine,
  RiToolsLine,
  RiArchiveLine,
  RiDashboard3Line,
  RiUserHeartLine,
  RiMegaphoneLine,
  RiStore3Line,
  RiAlarmWarningLine,
  RiFileShield2Line,
  RiFileChartLine,
  RiSettings3Line,
  RiTeamLine,
  RiShieldKeyholeLine,
  RiHistoryLine,
  RiDatabase2Line,
} from '@remixicon/react';
import type { NavSection } from './types';

/**
 * SOL MENÜNÜN TEK GERÇEK KAYNAĞI.
 *
 * Yeni bir modül eklemek = buraya bir satır + rota kaydı. Sidebar
 * bileşenine, breadcrumb'a veya başka bir yere dokunulmaz.
 *
 * HER ÖĞENİN İKONU VARDIR. Yalnızca bölüm başlıklarında ikon bulunmaz.
 * İkonsuz öğeler, göz taraması sırasında "eksik" gibi görünür ve menüde
 * hizalama bozulur — ikon sütunu boş kaldığı için etiketler kayar.
 *
 * HER ÖĞENİN YETKİSİ VARDIR. Yetkisi olmayan kullanıcı öğeyi HİÇ görmez;
 * tıklayıp 403 almaz. (Gerçek koruma sunucudadır; bu, kullanılabilirlik
 * içindir.)
 *
 * Sıralama bilinçlidir: günlük kullanım sıklığına göre. CİRO, müşterinin
 * öne çıkan ihtiyacı olduğu için finansın ÜSTÜNDE ve kendi bölümünde.
 */
export const NAV_SECTIONS: NavSection[] = [
  {
    id: 'dashboard',
    label: 'Pano',
    items: [
      {
        id: 'dashboard.overview',
        label: 'Yönetim Panosu',
        icon: RiDashboardLine,
        to: '/dashboard',
        scope: 'portfolio',
        permission: 'unit:read',
      },
      {
        id: 'dashboard.turnover',
        label: 'Ciro Analitiği',
        icon: RiLineChartLine,
        to: '/dashboard/ciro',
        scope: 'portfolio',
        permission: 'turnover:read',
      },
    ],
  },

  {
    id: 'portfolio',
    label: 'Portföy',
    items: [
      {
        id: 'portfolio.malls',
        label: "AVM'ler",
        icon: RiBuilding2Line,
        to: '/portfoy/avmler',
        scope: 'portfolio',
        permission: 'unit:read',
      },
      {
        id: 'portfolio.units',
        label: 'Mağaza Üniteleri',
        icon: RiStore2Line,
        to: '/portfoy/uniteler',
        scope: 'mall',
        permission: 'unit:read',
      },
      {
        id: 'portfolio.occupancy',
        label: 'Doluluk',
        icon: RiPieChartLine,
        to: '/portfoy/doluluk',
        scope: 'mall',
        permission: 'unit:read',
      },
    ],
  },

  {
    id: 'tenants',
    label: 'Kiracılar',
    items: [
      {
        id: 'tenants.list',
        label: 'Kiracılar',
        icon: RiUser3Line,
        to: '/kiracilar',
        scope: 'mall',
        permission: 'tenant:read',
      },
      {
        id: 'tenants.brands',
        label: 'Markalar',
        icon: RiStore3Line,
        to: '/kiracilar/markalar',
        scope: 'portfolio',
        permission: 'tenant:read',
      },
      {
        id: 'tenants.categories',
        label: 'Kategoriler',
        icon: RiPriceTag3Line,
        to: '/kiracilar/kategoriler',
        scope: 'mall',
        permission: 'tenant:read',
      },
    ],
  },

  {
    id: 'leases',
    label: 'Sözleşmeler',
    items: [
      {
        id: 'leases.list',
        label: 'Sözleşme Listesi',
        icon: RiFileTextLine,
        to: '/sozlesmeler',
        scope: 'mall',
        permission: 'lease:read',
      },
      {
        id: 'leases.expiry',
        label: 'Yaklaşan Bitişler',
        icon: RiCalendarCloseLine,
        to: '/sozlesmeler/bitisler',
        scope: 'mall',
        permission: 'lease:read',
      },
      {
        id: 'leases.securities',
        label: 'Teminatlar',
        icon: RiShieldStarLine,
        to: '/sozlesmeler/teminatlar',
        scope: 'mall',
        permission: 'lease:read',
      },
    ],
  },

  {
    id: 'turnover',
    label: 'Ciro',
    items: [
      {
        id: 'turnover.declarations',
        label: 'Beyanlar',
        icon: RiFileListLine,
        to: '/ciro/beyanlar',
        scope: 'mall',
        permission: 'turnover:read',
      },
      {
        id: 'turnover.entry',
        label: 'Beyan Girişi',
        icon: RiEditBoxLine,
        to: '/ciro/beyan-girisi',
        scope: 'mall',
        permission: 'turnover:write',
      },
      {
        id: 'turnover.approvals',
        label: 'Onay Kuyruğu',
        icon: RiCheckboxCircleLine,
        to: '/ciro/onay-kuyrugu',
        scope: 'mall',
        permission: 'turnover:approve',
      },
      {
        id: 'turnover.import',
        label: 'Excel Yükleme',
        icon: RiFileExcelLine,
        to: '/ciro/excel-yukleme',
        scope: 'mall',
        permission: 'turnover:write',
      },
      {
        id: 'turnover.rent',
        label: 'Ciro Kirası',
        icon: RiScales3Line,
        to: '/ciro/ciro-kirasi',
        scope: 'mall',
        permission: 'turnover:read',
      },
    ],
  },

  {
    id: 'finance',
    label: 'Finans',
    items: [
      {
        id: 'finance.accrual',
        label: 'Tahakkuk',
        icon: RiCalculatorLine,
        to: '/finans/tahakkuk',
        scope: 'mall',
        permission: 'accrual:read',
      },
      {
        id: 'finance.invoices',
        label: 'Faturalar',
        icon: RiBillLine,
        to: '/finans/faturalar',
        scope: 'mall',
        permission: 'invoice:read',
      },
      {
        id: 'finance.collections',
        label: 'Tahsilatlar',
        icon: RiHandCoinLine,
        to: '/finans/tahsilatlar',
        scope: 'mall',
        permission: 'accrual:read',
      },
      {
        id: 'finance.cam',
        label: 'Ortak Alan Gideri',
        icon: RiPieChart2Line,
        to: '/finans/oag',
        scope: 'mall',
        permission: 'accrual:read',
      },
      {
        id: 'finance.statement',
        label: 'Cari Hesap',
        icon: RiBook2Line,
        to: '/finans/cari-hesap',
        scope: 'mall',
        permission: 'accrual:read',
      },
    ],
  },

  {
    id: 'operations',
    label: 'Operasyon',
    items: [
      {
        id: 'operations.tickets',
        label: 'Talepler',
        icon: RiCustomerServiceLine,
        to: '/operasyon/talepler',
        scope: 'mall',
        permission: 'ticket:read',
      },
      {
        id: 'operations.workOrders',
        label: 'İş Emirleri',
        icon: RiClipboardLine,
        to: '/operasyon/is-emirleri',
        scope: 'mall',
        permission: 'ticket:read',
      },
      {
        id: 'operations.maintenance',
        label: 'Periyodik Bakım',
        icon: RiToolsLine,
        to: '/operasyon/bakim',
        scope: 'mall',
        permission: 'ticket:read',
      },
      {
        id: 'operations.assets',
        label: 'Varlıklar',
        icon: RiArchiveLine,
        to: '/operasyon/varliklar',
        scope: 'mall',
        permission: 'ticket:read',
      },
      {
        id: 'operations.meters',
        label: 'Sayaç Okumaları',
        icon: RiDashboard3Line,
        to: '/operasyon/sayaclar',
        scope: 'mall',
        permission: 'ticket:read',
      },
    ],
  },

  {
    id: 'analytics',
    label: 'Analitik',
    items: [
      {
        id: 'analytics.footfall',
        label: 'Ziyaretçi & Otopark',
        icon: RiUserHeartLine,
        to: '/analitik/ziyaretci',
        scope: 'mall',
        permission: 'report:read',
      },
    ],
  },

  {
    id: 'marketing',
    label: 'Pazarlama',
    items: [
      {
        id: 'marketing.events',
        label: 'Etkinlik Takvimi',
        icon: RiMegaphoneLine,
        to: '/pazarlama/etkinlikler',
        scope: 'mall',
        permission: 'report:read',
      },
      {
        id: 'marketing.specialty',
        label: 'Geçici Kiralama',
        icon: RiStore3Line,
        to: '/pazarlama/gecici-kiralama',
        scope: 'mall',
        permission: 'lease:read',
      },
    ],
  },

  {
    id: 'compliance',
    label: 'Güvenlik & Belge',
    items: [
      {
        id: 'compliance.incidents',
        label: 'Olay Kayıtları',
        icon: RiAlarmWarningLine,
        to: '/guvenlik/olaylar',
        scope: 'mall',
        permission: 'ticket:read',
      },
      {
        id: 'compliance.documents',
        label: 'Belgeler & Ruhsatlar',
        icon: RiFileShield2Line,
        to: '/guvenlik/belgeler',
        scope: 'mall',
        permission: 'lease:read',
      },
    ],
  },

  {
    id: 'reports',
    label: 'Raporlar',
    items: [
      {
        id: 'reports.index',
        label: 'Yönetim Raporu',
        icon: RiFileChartLine,
        to: '/raporlar',
        scope: 'mall',
        permission: 'report:read',
      },
    ],
  },

  {
    id: 'system',
    label: 'Sistem',
    items: [
      {
        id: 'system.parameters',
        label: 'Parametreler',
        icon: RiSettings3Line,
        to: '/sistem/parametreler',
        scope: 'mall',
        permission: 'parameter:write',
      },
      {
        id: 'system.users',
        label: 'Kullanıcılar',
        icon: RiTeamLine,
        to: '/sistem/kullanicilar',
        scope: 'portfolio',
        permission: 'user:manage',
      },
      {
        id: 'system.roles',
        label: 'Roller & Yetkiler',
        icon: RiShieldKeyholeLine,
        to: '/sistem/roller',
        scope: 'portfolio',
        permission: 'user:manage',
      },
      {
        id: 'system.audit',
        label: 'Denetim Kaydı',
        icon: RiHistoryLine,
        to: '/sistem/denetim',
        scope: 'portfolio',
        permission: 'audit:read',
      },
      {
        id: 'system.notifications',
        label: 'Bildirimler',
        icon: RiNotification3Line,
        to: '/sistem/bildirimler',
        scope: 'mall',
        permission: 'report:read',
      },
      {
        id: 'system.demoData',
        label: 'Demo Veri',
        icon: RiDatabase2Line,
        to: '/sistem/demo-veri',
        scope: 'portfolio',
        permission: 'user:manage',
      },
    ],
  },
];
